/**
 * WhatsApp: ülke kodu dahil yalnızca rakamlar (örn. Türkiye 905551234567).
 *
 * En kolayı: aşağıdaki INLINE_NUMBER içine numaranızı yazın (tırnaklı string).
 * Alternatif: `.env.local` → REACT_APP_WHATSAPP_NUMBER=905551234567
 * (Env dolu ve en az 10 haneli ise env kullanılır.)
 */
const INLINE_NUMBER = '905050267761';

function digitsOnly(value) {
  return String(value ?? '').replace(/\D/g, '');
}

const fromEnv = digitsOnly(
  String(process.env.REACT_APP_WHATSAPP_NUMBER ?? '').trim()
);

const fromFile = digitsOnly(INLINE_NUMBER);

export const WHATSAPP_NUMBER =
  fromEnv.length >= 10 ? fromEnv : fromFile;

const DEFAULT_MESSAGE =
  'Merhaba, davetiye / şekerlik hakkında bilgi almak istiyorum.';

export function getWhatsAppUrl(message = DEFAULT_MESSAGE) {
  if (!WHATSAPP_NUMBER) return null;
  const params = new URLSearchParams();
  if (message) params.set('text', message);
  const q = params.toString();
  return `https://wa.me/${WHATSAPP_NUMBER}${q ? `?${q}` : ''}`;
}
